import ImagesLoaded from 'imagesloaded';
import Cart from 'src/js/pages/cart';
import PublishButtons from 'src/js/components/publish_buttons';
import AddToWishlist from 'src/js/components/wishlist';

import Collapsible from 'src/js/pages/elements/collapsible';
import 'src/js/pages/elements/markdown';
import 'src/js/pages/elements/button';
import 'src/js/pages/elements/code';

$(document).on('turbo:load', function () {
  new PublishButtons();

  if ($('.add-to-wishlist-wrapper').length > 0) {
    new AddToWishlist();
  }

  processSideBySide();
  // handle resizeable videos
  $(".build-video, .build-pxt").fitVids({ customSelector: "iframe[src^='http://blip.tv'], iframe[src^='https://adafruit.pxt.io']"});

  // initialize element handling
  $('.markdown-element').markdownElement();
  $('.button-element').buttonElement();
  $('.code-element').codeElement();

  new Cart();
  new Collapsible;

  if ($('.product-image').length) {
    // on image errors, we replace with a missing image placeholder
    function replaceImage($element) {
      var missingImagePath = $element.data('error');
      $element.replaceWith(`<img src='${missingImagePath}' height='233' class='img-responsive'>`);
    }

    $('.product-image img').on('error', function() {
      replaceImage($(this));
    });

    $('.product-image video source').last().on('error', function() {
      replaceImage($(this).closest('video'));
    });
  }

  // show the image expand icon when hovering over himages
  if ($('body.pages .build-image').length) {
    $('.build-image').on('hover', function() {
      $('.image-expand', this).show();
    }, function() {
      $('.image-expand', this).hide();
    });
  }

  // spoiler functiionality
  if ($('.spoiler').length > 0) {
    $(document).on('click touchstart', '.spoiler', function(event) {
      $(this).toggleClass('tagged');
    });
  }

  //viewing single page view
  if ($('#page-wrapper.single-page').length > 0) {
    $('body').scrollspy({ target: '.sidebar-left' });

    // Expand and collapse sidebar pages
    $('.sidebar-left ul.page-child').collapse({toggle: false});
    $('.sidebar-left').on('activate.bs.scrollspy', function (e) {
      var $section = $(e.target).hasClass('parent') ? $(e.target) : $(e.target).parent().parent();
      var $currentIcon = $section.find('a.collapsed-icon');
      var $currentChildList = $section.find('ul.page-child');

      $('.sidebar-left a.collapsed-icon').not($currentIcon).addClass("collapsed");
      $('.sidebar-left ul.page-child').not($currentChildList).collapse('hide');
      if ($currentIcon.length > 0) {
        $currentIcon.removeClass('collapsed');
        $currentChildList.collapse('show');
      }
    })
  }

  if ($('.sidebar-left-content').length > 0 && $('.sidebar-left-content').find('.collapsed-icon').length < 1) {
    ImagesLoaded('.related-guides-wrapper, .sidebar-left-content', function(){
      var affix_timer;
      var affixed = false;
      var $sidebar = $('.sidebar-left-content');
      var $content = $('.content');

      var affixFn = function() {
        $(window).off('.affix');
        $sidebar.removeClass("affix affix-top affix-bottom").removeData("bs.affix");

        //sidebar needs to be fully visible in the window.
        if (($sidebar.outerHeight(true) < $(window).height()) && ($(window).width() > 768)) {
          //sidebar has to be taller than the actual content.
          if (($sidebar.outerHeight(true) < $content.outerHeight(true))) {
            var messageHeight = $('#messaging-alert').is(":visible") ? $('#messaging-alert').outerHeight(true) : 0;
            //affix the sidebar.
            $sidebar.affix({
              offset: {
                top: function () {
                  return (this.top = ($('#adafruit-header').outerHeight(true) + messageHeight));
                },
                bottom: function () {
                  var baseHeight = $('#adafruit-footer').outerHeight(true) + ($('.related-guides-wrapper').outerHeight(true) || 0) + 340;
                  if ($(window).width() <= 1024) { //medium screen width
                    baseHeight += $('.sidebar-right-wrapper').outerHeight(true)
                  }

                  return (this.bottom = baseHeight);
                }
              }
            });
          }
        }
      };

      affixFn();
      $(window).on('resize', function() {
        clearTimeout(affix_timer);
        affix_timer = setTimeout(affixFn, 100);
      });
    });

    $('[data-clampedwidth]').each(function () {
        var elem = $(this);
        var width_timer;
        var parentPanel = elem.data('clampedwidth');
        var resizeFn = function () {
          var sideBarNavWidth = $(parentPanel).width() - parseInt(elem.css('paddingLeft')) - parseInt(elem.css('paddingRight')) - parseInt(elem.css('marginLeft')) - parseInt(elem.css('marginRight')) - parseInt(elem.css('borderLeftWidth')) - parseInt(elem.css('borderRightWidth'));
          elem.css('width', sideBarNavWidth);
        };

        resizeFn();
        $(window).on('resize', function() {
          clearTimeout(width_timer);
          width_timer = setTimeout(resizeFn, 100);
        });
    });
  }

  /* parse out URL, and get the gist details from github. */
  $('.build-gist').each(function() {
    var $gist_element = $(this);
    var gist_url = $gist_element.html();

    $.ajax({
      url: gist_url + '.json',
      dataType: 'jsonp',
      success: function(gist) {
        $gist_element.html(gist.div);
        $gist_element.show();
      }
    });
  });

  $('.medium-side-image-link').on('touchstart click mouseenter', function(event) {
    var content_width = $('.content').width();
    if ($('#admin').length > 0) {
      return;
    }
    //no need to show the larger of the side-by-side images in the small browsers...just doesn't look good.
    //so prevent the hover, click event in that case.
    if (content_width > 450) {
      event.preventDefault();

      var large_link = $(this).attr('href');
      $(this).parents('ul').find('.large-side-image-link').attr('href', large_link);

      if ($(this).find('img').length) {
        var medium_link = $('.small-side-image', this).attr('src').replace(/\/thumb160\//, "/medium640/");
        $(this).parents('ul').find('.medium-side-image').attr('src', medium_link);
      } else {
        var medium_link = $('.small-side-image source', this).attr('src').replace(/\/small360/, "/medium640");
        $(this).parents('ul').find('.medium-side-image source').attr('src', medium_link);
        $(this).parents('ul').find('.medium-side-image')[0].load();
      }
    }
  });
});

$(function() {

  $(document).on('ajax:success', '#remote-modal-form', function(event, data, status, xhr){
    var url = xhr.getResponseHeader('Location');
    if (url) {
      // Redirect to url
      window.location = url;
    } else {
      // Update modal content
      var modal = $(data).html();
      $('#remote-modal').html(modal).modal('show');
    }

    return false;
  });

  $(document).on("ajax:success", '.feedback-link', function(event, data, status, xhr) {
      var response = xhr.responseText;
      $('#feedback-modal').remove();
      $(response).appendTo('body');

      $('#feedback-modal').modal('show');
  });

  $(window).on('resize', function() {
    //adjustPageSidebar();
    processSideBySide();
  });

  $(document).on('touchstart click', '.related-guide', function() {
    window.location = $(this).find('a').attr('href');
  });
});

function processSideBySide() {
  var $content = $('.content');

  //not really optimal here, causes double image refresh on mobile browsers for side2...
  if ($(window).width() <= 770) {
    $('.small-side-image').each(function(index, image) {
      var src = $(image).attr('src');
      $(image).attr('src', src.replace('thumb160', 'medium640'));
    });
  }
}
